import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { mauiConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={mauiConfig} />;
}